import React from "react"
import { cn } from "@/lib/utils"

export const InteractiveHoverButton = React.forwardRef(({ children, className, ...props }, ref) => {
  return (
    <button ref={ref} className={cn("group relative w-auto cursor-pointer overflow-hidden rounded-full border bg-background p-2 px-6 text-center font-semibold", className)} {...props}>
      <div className="flex items-center gap-2">
        {/* Dot animation */}
        <div className="h-2 w-2 rounded-full bg-primary transition-transform duration-1000 delay-100 ease-in-out group-hover:scale-[100]"></div>

        {/* Text that fades and moves out */}
        <span className="inline-block transition-all duration-1000 delay-100 group-hover:translate-x-8 group-hover:opacity-0">{children}</span>
      </div>

      {/* Text that fades and slides in */}
      <div className="absolute top-0 z-10 flex h-full w-full translate-x-8 items-center justify-center gap-2 text-primary-foreground opacity-0 transition-all duration-1000 delay-100 group-hover:-translate-x-6 group-hover:opacity-100">
        <div>{children}</div>
      </div>
    </button>
  )
})

InteractiveHoverButton.displayName = "InteractiveHoverButton"
